import { render, staticRenderFns } from "./ThumbDownIcon.vue?vue&type=template&id=5ebd28c6&"
import script from "./ThumbDownIcon.vue?vue&type=script&lang=ts&"
export * from "./ThumbDownIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports